var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsVinNumberWindowVehicleFront(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "mlfs6rueja",
    d: "M24.776 7.395c-.363 1.04-.606 2.135-.713 3.27l-.117.016c-2.177.307-4.328.746-6.44 1.309l-.903.249 10.922 23.435c1.305-.203 2.641-.324 3.975-.324 4.423 0 8.72 1.191 12.638 3.12l.488.246 13.967-21.324c-2.179-1.259-4.433-2.36-6.749-3.297.103-.683.156-1.383.156-2.095 0-.413-.018-.822-.053-1.225 3.627 1.39 7.078 3.137 10.31 5.194l.743.48-17.377 26.493C41.568 40.262 36.72 38.5 31.5 38.5c-.696 0-1.39.043-2.074.107l-.51.052 2.87 6.172c1.603.146 2.864 1.48 2.864 3.121 0 1.74-1.41 3.15-3.15 3.15s-3.15-1.41-3.15-3.15c0-.598.17-1.156.46-1.632l.115-.174-3.223-6.922c-2.806.7-5.438 1.874-7.81 3.365l-.505.324L0 16.45c7.271-4.779 15.703-7.983 24.776-9.054zM13.567 13.19c-2.878 1.005-5.674 2.246-8.358 3.73l-.802.452 13.98 21.32c1.693-.863 3.467-1.584 5.292-2.137l.687-.2-10.799-23.165zM38.2 0c6.185 0 11.2 5.015 11.2 11.2 0 6.186-5.014 11.2-11.2 11.2-6.186 0-11.2-5.014-11.2-11.2C27 5.015 32.015 0 38.2 0zm0 3.2c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zm4.195 3.93c.295.211.389.609.235.93l-.054.093-4.605 6.259c-.234.349-.699.416-1.017.17l-.076-.068-3.669-3.77c-.279-.287-.279-.753 0-1.04.255-.26.652-.283.931-.07l.08.07 3.063 3.147L41.4 7.317c.225-.334.67-.417.995-.186z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-899 -517) translate(258 288) translate(579 229) translate(62) translate(1 6)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ychrqdps2b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#mlfs6rueja"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#BA4E00",
    xlinkHref: "#mlfs6rueja"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#00095B",
    mask: "url(#ychrqdps2b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L64 0 64 64 0 64z",
    transform: "translate(-1 -6)"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsVinNumberWindowVehicleFront);
export default __webpack_public_path__ + "static/media/icons-vin-number-window-vehicle-front.85727390a7a08d4fa2828e29504011cc.svg";
export { ForwardRef as ReactComponent };